var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 25.5C19.4036 25.5 25 19.9036 25 13C25 6.09644 19.4036 0.5 12.5 0.5C5.59644 0.5 0 6.09644 0 13C0 19.9036 5.59644 25.5 12.5 25.5Z",
    fill: "url(#paint0_linear_8_966)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.38327 13.5324C5.8515 12.7301 7.49045 12.0604 9.0218 11.3873C11.6563 10.2848 14.3013 9.20148 16.973 8.19288C17.4928 8.02104 18.4268 7.85301 18.5184 8.61723C18.4682 9.69904 18.2619 10.7745 18.1204 11.85C17.7613 14.215 17.3462 16.572 16.9414 18.9292C16.8019 19.7144 15.8105 20.1209 15.1761 19.6184C13.6515 18.5968 12.1153 17.585 10.6102 16.5397C10.1172 16.0427 10.5743 15.3289 11.0147 14.974C12.2703 13.7463 13.602 12.7032 14.792 11.4121C15.113 10.643 14.1645 11.2911 13.8517 11.4898C12.1327 12.665 10.4557 13.912 8.64335 14.9449C7.71759 15.4505 6.63861 15.0184 5.71326 14.7363C4.8836 14.3955 3.6678 14.0522 4.38318 13.5325L4.38327 13.5324Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8_966",
    x1: 8.99644,
    y1: -11.0732,
    x2: -8.08861,
    y2: 16.5501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34B0DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E88D3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTgLogo);
export default __webpack_public_path__ + "static/media/tg-logo.b577d60ce3ef9d65d31042cbae9cbaca.svg";
export { ForwardRef as ReactComponent };